import { connect } from 'react-redux'
import ResizeListener from './ResizeListener.js';
import { windowResize } from '../../actionCreators';

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onResize: (dimensions) => dispatch(windowResize(dimensions))
});

export default connect(mapStateToProps, mapDispatchToProps)(ResizeListener);


// WEBPACK FOOTER //
// ./src/components/ResizeListener/ResizeListenerContainer.js